import * as React from 'react';
import { FooterLinkList } from './FooterLinkList';
const facebookIconUrl = require('../../../../icons/facebook.svg');
const instagramIconUrl = require('../../../../icons/instagram.svg');
const twitterIconUrl = require('../../../../icons/twitter.svg');
import './style.css';

export class FooterLinksModel {
  constructor(
    public title: string,
    public className: string,
    public links: Array<FooterLinkModel>
  ) {}
}

export class FooterLinkModel {
  constructor(
    public title: string,
    public url: string,
    public icon?: string,
    public className?: string
  ) {}
}

export interface FooterLinksProps {
  /* empty */
}

export interface FooterLinksState {
  /* empty */
}

export class FooterLinks extends React.Component<
  FooterLinksProps,
  FooterLinksState
> {
  public static edgeOfPlayLinks: FooterLinksModel = new FooterLinksModel(
    `Edge of Play links`,
    `edge-of-play-links`,
    [
      new FooterLinkModel(`Contact Us`, `/contact`),
      new FooterLinkModel(`About Us`, `/about`)
    ]
  );

  public static legalAndPolicyLinks: FooterLinksModel = new FooterLinksModel(
    `Legal & Policies`,
    `legal-and-policy-links`,
    [
      new FooterLinkModel(`Privacy Policy`, `/privacy`),
      new FooterLinkModel(`Terms & Conditions`, `/terms`)
    ]
  );

  /* TODO: Extract to store... */
  public static socialLinks: FooterLinksModel = new FooterLinksModel(
    `Follow Us`,
    `social-links`,
    [
      new FooterLinkModel(
        `Facebook`,
        `https://www.facebook.com/edgeofplay/`,
        facebookIconUrl
      ),
      new FooterLinkModel(
        `Twitter`,
        `https://twitter.com/edgeofplay`,
        twitterIconUrl
      ),
      new FooterLinkModel(
        `Instagram`,
        `https://www.instagram.com/edgeofplay/`,
        instagramIconUrl,
        `footer-link-instagram`
      )
    ]
  );

  render() {
    return (
      <div className="footer-links">
        <div className="footer-links-section edge-of-play-summary">
          Bringing cutting edge coaching material for the sports you love right
          to your fingertips.
        </div>
        <FooterLinkList links={FooterLinks.edgeOfPlayLinks} />
        <FooterLinkList links={FooterLinks.legalAndPolicyLinks} />
        <FooterLinkList links={FooterLinks.socialLinks} />
      </div>
    );
  }
}

export default FooterLinks;



// WEBPACK FOOTER //
// ./src/app/components/App/Footer/FooterLinks/index.tsx